import { createSelector } from '@reduxjs/toolkit';

const dialogByNameSelector = (state: any, props: any) =>
  state.dashboard.dialogs?.[props.dialogName];

export const isDialogOpenFactory = () =>
  createSelector(dialogByNameSelector, (dialog: any) => {
    return dialog && dialog.isOpen;
  });

export const getDialogPayloadFactory = () =>
  createSelector(dialogByNameSelector, (dialog: any) => {
    return { ...dialog?.payload };
  });

const alertByNameSelector = (state: any, props: any) =>
  state.dashboard.alerts?.[props.name];

export const isAlertOpenFactory = () =>
  createSelector(alertByNameSelector, (alert: any) => {
    return alert && alert.isOpen;
  });

export const getAlertPayloadFactory = () =>
  createSelector(alertByNameSelector, (alert: any) => {
    return { ...alert?.payload };
  });

const drawerByNameSelector = (state: any, props: any) =>
  state.dashboard.drawers?.[props.name];

export const isDrawerOpenFactory = () =>
  createSelector(drawerByNameSelector, (drawer: any) => {
    return drawer && drawer.isOpen;
  });

export const getDrawerPayloadFactory = () =>
  createSelector(drawerByNameSelector, (drawer: any) => {
    return { ...drawer?.payload };
  });

const featuresSelector = (state: any, props: any) => {
  return state.dashboard.features;
};

export const getDashboardFeaturesSelector = () =>
  createSelector(featuresSelector, (features: any) => {
    return features;
  });
